<div class="animated fadeIn home">
    <div class="row">
        <div class="col-12">
            <h2>View planting sites</h2>
            <div class="browse">
                <div class="form-group">
                    <div class="form-control multiselect form-control-lg">
                        <ng-select
                                   placeholder="All countries"
                                   [ngModel]="country"
                                   (ngModelChange)="setCountry($event)"
                                   [searchable]="false">
                            <ng-option [value]="undefined">All countries</ng-option>
                            <ng-option *ngFor="let c of countries" [value]="c">{{c}}</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="form-group" [class.added-date]="!!date">
                    <input type="text"
                           class="form-control form-control-lg datepicker"
                           [minDate]="minDate"
                           [bsConfig]="{minMode: 'year', dateInputFormat: 'YYYY'}"
                           [maxDate]="maxDate"
                           [(ngModel)]="date"
                           placeholder="All years of planting"
                           readonly
                           bsDatepicker>
                    <button class="clear-date" (click)="date = null"><img src="/assets/img/x.svg"/></button>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary btn-lg" [routerLink]="['/plantingSite', 'list', 'map']" [queryParams]="{country: country, year: date?.getFullYear()}">BROWSE</button>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="or">
                OR
            </div>
        </div>
        <div class="col-12">
            <div class="form-group search">
                <div class="input-group">
                    <input class="form-control form-control-lg"
                           [(ngModel)]="searchText"
                           (keydown.enter)="toSearch()"
                           placeholder="{{generalSearchPlaceHolder}}">
                    <span class="input-group-append">
                        <button class="btn btn-primary"
                                type="button"
                                [routerLink]="['/plantingSite', 'list', 'map']"
                                [queryParams]="{search: searchText}">
                            <i class="icon-magnifier"></i>
                        </button>
                    </span>
                </div>
                <p>{{generalPlaceholderPC}}</p>
            </div>
        </div>
    </div>
</div>
